import * as messages from '@radnuc/messages';
import * as thrift from 'thrift';
import { Buffer } from 'buffer';
//import { Config as BaseConfig } from '@radnuc/react-ui-components';

import {immerable, produce} from "immer";

async function queryConfig(component: messages.ConfigurationState.ConfigComponent) {
    const componentName = messages.ConfigurationState.ConfigComponent[component];
    let port = window.location.port;
    if (window.location.port === '3000')
        port = '8301';
    const response = await fetch('http://' + window.location.hostname + ':'+port+'/TGW1hNlSwjaNFF96k4QQ9RXFNeiEqRab/' +
        `config/${componentName}`);

    if (response.status !== 200)
        throw new Error(`Bad return code: ${response.status}`);

    const data = await response.arrayBuffer();

    const typed_data = Buffer.from(data);
    const transport = new thrift.TFramedTransport(typed_data);
    const protocol = new thrift.TBinaryProtocol(transport);

    const result = new messages.ConfigurationState.ConfigResponseGet()
    result.read(protocol);
    return result;
}

export async function setConfig(message: messages.ConfigurationState.ConfigMessage) {
    let packed_data: Buffer | null = null;
    let transport = new thrift.TFramedTransport(undefined, function (msg, seqid) {
        if (!msg) return;

        // Remove 4-byte header from FramedTransport
        packed_data = msg.slice(4);
    });

    let protocol = new thrift.TBinaryProtocol(transport);
    message.write(protocol);
    transport.flush();

    if (packed_data === null)
        return;

    try {
        let port = window.location.port;
        if (window.location.port === '3000')
            port = '8301';
        let response = await fetch('http://' + window.location.hostname + ':'+port+'/TGW1hNlSwjaNFF96k4QQ9RXFNeiEqRab/' +
            `config/update`, {
                method: 'POST',
                body: packed_data
            });

        if (response.status !== 200)
            throw new Error(`Bad return code: ${response.status}`);
    } catch(err) {
        console.log(err);
    }
}

interface EnableFlags {
    investigation?: boolean,
    pcs?: boolean,
    neutron?: boolean,
    reporting?: boolean,
    inv?: boolean,
    agg?: boolean,
}

export class Config {
    [immerable] = true;

    pcs?: messages.ConfigurationState.PCSConfig
    neutron?: messages.ConfigurationState.NeutronConfig
    reporting?: messages.ConfigurationState.SigmaEdgeConfig
    inv?: messages.ConfigurationState.InvestigationConfig
    agg?: messages.ConfigurationState.AggConfig

    enableFlags: {pcs:boolean, neutron:boolean, reporting:boolean, inv:boolean, agg:boolean }

    constructor(enable?: EnableFlags) {
        //super()
        this.enableFlags = {pcs:true,neutron:true,reporting:true,inv:true,agg:false};
        if(enable){
            if(enable.pcs){
                this.enableFlags.pcs = true;
            } else {
                this.enableFlags.pcs = false;
            }
            if(enable.neutron){
                this.enableFlags.neutron = true;
            } else {
                this.enableFlags.neutron = false;
            }
            if(enable.reporting){
                this.enableFlags.reporting = true;
            } else {
                this.enableFlags.reporting = false;
            }
            if(enable.inv){
                this.enableFlags.inv = true;
            } else {
                this.enableFlags.inv = false;
            }
            if(enable.agg){
                this.enableFlags.agg = true;
            } else {
                this.enableFlags.agg = false;
            }
        }
    }

    update(message: messages.ConfigurationState.ConfigMessage) {
        if (message.messageType !== messages.ConfigurationState.ConfigMessageType.VALUE_REPORT)
            return this;

        if (message.component === messages.ConfigurationState.ConfigComponent.PCS) {
            return produce(this, draft => {
                draft.pcs = message.pcs;
            });
        } else if (message.component === messages.ConfigurationState.ConfigComponent.NEUTRON) {
            return produce(this, draft => {
                draft.neutron = message.neutron;
            });
        } else if (message.component === messages.ConfigurationState.ConfigComponent.INVESTIGATION) {
            return produce(this, draft => {
                draft.inv = message.inv;
            });
        } else if (message.component === messages.ConfigurationState.ConfigComponent.SIGMA_EDGE) {
            return produce(this, draft => {
                draft.reporting = message.sigmaEdge;
            });
        } else if (message.component === messages.ConfigurationState.ConfigComponent.AGG) {
                return produce(this, draft => {
                    draft.agg = message.agg;
                });
        } else {
            return this;
        }
    }

    clear() {
        return new Config();
    }

    missingComponents() {
        return (
            (this.enableFlags?.pcs && this.pcs === undefined) ||
            (this.enableFlags?.reporting && this.reporting === undefined) ||
            (this.enableFlags?.neutron && this.neutron === undefined) ||
            (this.enableFlags?.inv && this.inv === undefined) ||
            (this.enableFlags?.agg && this.agg === undefined)
        )
    }

    safeToUpdate(prev: Config) {
        let result:boolean = true;
        if(this.enableFlags?.pcs && prev.pcs !== undefined && prev.pcs !== this.pcs){
            result = false;
        }
        if(this.enableFlags?.reporting && prev.reporting !== undefined && prev.reporting !== this.reporting){
            result = false;
        }
        if(this.enableFlags?.neutron && prev.neutron !== undefined && prev.neutron !== this.neutron){
            result = false;
        }
        if(this.enableFlags?.inv && prev.inv !== undefined && prev.inv !== this.inv){
            result = false;
        }
        if(this.enableFlags?.agg && prev.agg !== undefined && prev.agg !== this.agg){
            result = false;
        }
        return result;
    }

    async queryComponentUpdate(component: messages.ConfigurationState.ConfigComponent) {
        try {
            const data = await queryConfig(component)
            if (data.errorMessage) {
                throw new Error(`Received error: ${data.errorMessage}`)
            }
            return this.update(data.response);
        } catch(err) {
            return this;
        }
    }

    queryUpdate() {
        let promise = Promise.resolve(this);
        if (this.enableFlags?.pcs && this.pcs === undefined) {
            promise = promise.then((config) => {
                return config.queryComponentUpdate(messages.ConfigurationState.ConfigComponent.PCS);
            })
        }
        if (this.enableFlags?.neutron && this.neutron === undefined) {
            promise = promise.then((config) => {
                return config.queryComponentUpdate(messages.ConfigurationState.ConfigComponent.NEUTRON);
            })
        }
        if (this.enableFlags?.reporting && this.reporting === undefined) {
            promise = promise.then((config) => {
                return config.queryComponentUpdate(messages.ConfigurationState.ConfigComponent.SIGMA_EDGE);
            });
        }
        if (this.enableFlags?.inv && this.inv === undefined) {
            promise = promise.then((config) => {
                return config.queryComponentUpdate(messages.ConfigurationState.ConfigComponent.INVESTIGATION);
            });
        }
        if (this.enableFlags?.agg && this.agg === undefined) {
            promise = promise.then((config) => {
                return config.queryComponentUpdate(messages.ConfigurationState.ConfigComponent.AGG);
            });
        }
        return promise;
    }
}

export default Config
